<template>
  <div :class="classes">
    <div ref="container"
         :class="['container', {'loginPro': type && typeToggle === 1}, {'divErCode': type && typeToggle === 2}]">
         <!-- loginPro -> 账密，divErCode -> 手机号 -->
      <slot name="logo"></slot>
      <keep-alive>
        <!--typeToggle!==1-->
        <template v-if="typeToggle != 1">
          <PhoneLogin
                  :phoneExp="phoneExp"
                  :loginType="type"
                  :TypeToggle="typeToggle"
                  @toggle="toggle"
                  ref="PhoneLogin"
          ></PhoneLogin>
        </template>
        <!--typeToggle===1-->
        <template v-else-if="!type || typeToggle === 1">
          <AccountLogin
                  :loginType="type"
                  :TypeToggle="typeToggle"
                  @toggle="toggle"
                  ref="AccountLogin"
          >
          </AccountLogin>
        </template>
      </keep-alive>
      <div @click="login">
        <template v-if="$slots.loginBtn">
          <slot name="loginBtn"></slot>
        </template>
        <!-- <div  id="btn" class="btn"/> -->
        <Button v-if="!$slots.loginBtn" type="text" id="btn" class="btn"><Icon v-if="spinShow" type="ios-loading" />{{t('登录')}}</Button>
      </div>
      <!-- <div v-if="!type || typeToggle === 1" class="forgotPassword" @click="resetPassword()">{{t('忘记密码')}}?</div> -->
      <div class="other-login-box" style="display: none;">
        <div class="para-widget-third-login__title">
          <div class="para-widget-third-login__line before"></div>
          <span class="para-widget-third-login__text para-widget-auto-tips">{{t('第三方登录')}}</span>
          <div class="para-widget-third-login__line after"></div>
        </div>
        <div class="oauth-box">
          <!-- <span>其它登录：</span> -->
          <a :title="t('sso登录')">SSO</a>
          <a class="iconfont icon-wechat-"></a>
          <a class="iconfont icon-dingding01"></a>
        </div>
      </div>
      <!-- <Spin v-show="spinShow" fix>
        <div class="loader">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" fill="none" stroke-width="5" stroke-miterlimit="10"/>
          </svg>
        </div>
      </Spin> -->
    </div>
    <el-dialog append-to-body @close="clearForm('updatePwdForm')"  :visible.sync="dialogShow" :title="t('找回密码')" :close-on-click-modal="false" :close-on-press-escape="false" width="470px" class="forgotPwdModal">
      <div class="warning"> {{messtip}} </div>
      <el-form :model="updatePwdForm" ref="updatePwdForm" :rules="rules" label-width="60px">
        <el-form-item :label="t('用户名')+'：'" prop="name" :label-width="labelWidth" >
          <el-input  prefix-icon="el-icon-user" v-model="updatePwdForm.name" border :placeholder="t('请输入用户名')" clearable />
        </el-form-item>
        <!-- <i class="color-red "  style="position: absolute;top:116px;left:80px">*</i> -->
        <el-form-item :label="t('邮箱')+'：'" prop="email" :label-width="labelWidth" >
          <el-input  prefix-icon="el-icon-message" v-model="updatePwdForm.email" border :placeholder="t('请输入邮箱地址')" clearable readonly="readonly" />
        </el-form-item>
        <el-form-item :label="t('新密码')+'：'" prop="newpassword" :label-width="labelWidth">
          <el-input  prefix-icon="el-icon-lock" v-model="updatePwdForm.newpassword" border :placeholder="t('请输入新密码')" show-password clearable autocomplete = "off" />
        </el-form-item>
        <el-form-item :label="t('确认密码')+'：'" prop="confirmpassword" :label-width="labelWidth" >
          <el-input prefix-icon="el-icon-lock" v-model="updatePwdForm.confirmpassword" border :placeholder="t('请输入确认密码')" show-password clearable autocomplete = "off" />
        </el-form-item>
        <el-form-item :label="t('验证码')+'：'" prop="code" :label-width="labelWidth" class="codeClass">
          <el-input prefix-icon="el-icon-key" :placeholder="t('请填写验证码')"  maxlength="6" v-model="updatePwdForm.code">
          <el-button slot="append" @click="sendEmailCode()" :disabled="disabled" border >{{ msg }}</el-button>
        </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">{{t('取 消')}}</el-button>
        <el-button type="primary" :loading="checkLoading" @click="handleSubmit('updatePwdForm')">{{t('确 定')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';
  import AccountLogin from './AccountLogin';
  import PhoneLogin from './PhoneLogin';
  import { enableGateWay, Version, encryptedPassword, classFix, enableLoginPro, enableChangeLang, enableInitializationRequest, cbs, dateStorageTime} from './login.config';
  // import network, {urlSearchParams} from '../../__utils__/network';
  import { emptyRecord } from './indexedDB';
  // import DispatchEvent from '../../__utils__/dispatchEvent';
  // import { hideMenu, launchNetworkMonitor } from '../../__config__/event.config';
  const { network, urlSearchParams } = R3;
  const hideMenu = () => {
    document.body.addEventListener('click', () => {
      if (vm.$store.state.global.primaryMenuIndex !== -1) {
        vm.$store.commit('global/hideMenu');
      }
    });
  };
  const launchNetworkMonitor = () => {
    window.addEventListener('keydown', (e) => {
      if (e.altKey && e.key.toLowerCase() === 'n') {
      window.vm.$router.push({
          path: `${PLUGIN_MODULE_PREFIX}/NETWORKMONITOR`
        });
      }
    });
  };

  export default {
    name: 'LoginCore',
    components: {AccountLogin, PhoneLogin},
    data() {
      var email = (rule, value, callback) => {
        if(!value) {
          return callback(new Error(t('请输入邮箱')))
        }else if(!/^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/.test(value)) {
          return callback(new Error(t('请输入正确的邮箱')))
        }else {
          callback()
        }
      };
      return {
        dialogShow : false,
        disabled: false,
        msg: t('点击获取验证码'),
        checkLoading: false,
        count: 15,
        timer: 0,
        labelWidth: '120',
        messtip:'',
        updatePwdForm: {
					email: '',
          name: '',
					newpassword: '',
					confirmpassword: '',
          code: ''
				},
        rules: {
					email: [{required: true, validator: email, trigger: 'blur'}],
					code: [{required: true, message: t('请输入验证码'), trigger: 'blur'}],
					name: [{required: true, message: t('请输入用户名'), trigger: 'blur'}],
					newpassword: [
						{
							required: true,
							message: t('请输入新密码'),
							trigger: 'blur',
						},
						{
							min: 6,
							max: 18,
							message: t('密码长度6-18位'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								const {newpassword} = this.updatePwdForm
								var reg = new RegExp(/^(?=.*?\d)(?=.*?[a-z])(?=.*?[A-Z]).{6,18}$/);
								if(!reg.test(newpassword)){
                  const mes = t('密码中必须包含数字及大小写字母!')
                  callback(new Error(mes))
								} else {
                  callback()
                }
							},
							trigger: 'blur'
						}
					],
					confirmpassword: [
						{
							required: true,
							message: '请输入确认密码',
							trigger: 'blur',
						},
						{
							min: 6,
							max: 18,
							message: t('密码长度6-18位'),
							trigger: 'blur'
						},
						{
              validator: (rule, value, callback) => {
								const {newpassword, confirmpassword} = this.updatePwdForm
                  if (newpassword !== confirmpassword) {
                    const mes = t('两次密码输入不一致!')
                    callback(new Error(mes))
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
						}
					]
				},
        globalServiceId: window.localStorage.getItem('serviceId') || '',
        type: enableLoginPro,
        spinShow: false, // loading是否显示
        typeToggle: 2, // 1帐密 2验证码
        flag: 1,
        lang: 'zh',
        moveClass:window.ProjectConfig &&  window.ProjectConfig.moveBar ? 'loginMove':'',
        showChangeLang: enableChangeLang || false,
      }

    },
    props: {
      loginSucCbk: {
        type: Function
      },
      phoneExp: {
        type: RegExp,
        default: () => /^\d{11,11}$/
      },
    },
    created () {
      window.addEventListener('keydown', this.enter)
    },
    destroyed () {
      window.removeEventListener('keydown', this.enter)
    },

    computed: {
      classes() {
        return [
          `${classFix}loginCore ${this.moveClass}`,
        ];
      },
    },
    methods: {
      ...mapActions('global', ['getMenuLists']),

      ...mapMutations('global', ['emptyTabsCache']),

      enter(e) {
        const key = e.keyCode;
        if (key === 13) {
          this.login();
        }
      },

      login() {
        this.spinShow = true;
        const globalServiceId = window.localStorage.getItem('serviceId');
        const randomKey = btoa(`${Math.random() * 10000000000}`).substring(0, 5);
        let message = {};
        if (!this.type) {
          const {username, password,movebar,gdCode} = this.$refs.AccountLogin.$refs;
          if (username.value === '') {
            message = {
              title: t('错误'),
              content: t('请输入用户名'),
              mask: true,
            };
            this.spinShow = false;
            this.$Modal.fcError(message);
          } else if (password.value === '') {
            message = {
              title: t('错误'),
              content: t('请输入密码'),
              mask: true,
            };
            this.spinShow = false;
            this.$Modal.fcError(message);
          } else if (gdCode.value === '') {
            message = {
              title: t('错误'),
              content: t('请输入固定验证码'),
              mask: true,
            };
            this.spinShow = false;
            this.$Modal.fcError(message);
          } else {
            if(window.ProjectConfig &&  window.ProjectConfig.moveBar && !movebar.verifyBar){
                message = {
                  title: t('错误'),
                  content: t('请按住滑块，拖动到最右侧'),
                  mask: true,
                };
                this.spinShow = false;
                this.$Modal.fcError(message);
               return false;
            }
            const param = {
              fixedCode: gdCode.value,
              username: username.value,
              password: encryptedPassword() ? `${randomKey}${btoa(password.value)}` : password.value,
              captcha: '',
              encrypted: encryptedPassword(),
              rememberMe: false,
              lang: 'zh_CN',
            };
            this.loginNet('/p/c/login', globalServiceId, param)
          }
        } else {
          if (this.typeToggle === 1) { // 账号密码
            if (this.$refs.AccountLogin.$refs.username.value === '') {
              message = {
                title: t('错误'),
                content: t('请输入用户名'),
                mask: true,
              };
              this.spinShow = false;
              this.$Modal.fcError(message);
            } else if (this.$refs.AccountLogin.$refs.password.value === '') {
              message = {
                title: t('错误'),
                content: t('请输入密码'),
                mask: true,
              };
              this.spinShow = false;
              this.$Modal.fcError(message);
            } else if (!this.$refs.AccountLogin.$refs.gdCode.value) {
              this.spinShow = false;
              this.$Modal.fcError({
                title: t('错误'),
                content: t('请输入固定验证码'),
                mask: true,
              });
            } else {
              const param = {
                username: this.$refs.AccountLogin.$refs.username.value,
                password: this.$refs.AccountLogin.$refs.password.value,
                fixedCode: this.$refs.AccountLogin.$refs.gdCode.value,
                key: this.$refs.AccountLogin.key,
                flag: this.flag
              };
              this.loginNet('/p/c/login', globalServiceId, param)
            }
          }
          if (this.typeToggle === 2) { // 手机验证码
            if (!this.$refs.PhoneLogin.$refs.phone.value) {
              this.spinShow = false;
              this.$Modal.fcError({
                title: t('错误'),
                content: t('请输入手机号'),
                mask: true,
              });
            } else if (!(this.phoneExp.test(this.$refs.PhoneLogin.$refs.phone.value))) {
              this.spinShow = false;
              this.$Modal.fcError({
                title: t('错误'),
                content: t('请输入正确的手机号'),
                mask: true,
              })
            }else if (!this.$refs.PhoneLogin.$refs.sendcode.value) {
              this.spinShow = false;
              this.$Modal.fcError({
                title: t('错误'),
                content: t('请输入短信验证码'),
                mask: true,
              });
            } else {
              const param = {
                phone: this.$refs.PhoneLogin.$refs.phone.value,
                verificationCode: this.$refs.PhoneLogin.$refs.sendcode.value,
                flag: this.flag
              };
              this.loginNet('/p/c/login', globalServiceId, param)
            }
          }
        }
      },
      toggle(num) {
        this.typeToggle = num;
      },
      getCaptcha(globalServiceId) {
        return new Promise(resolve => {
          network.post(enableGateWay() ? `/${globalServiceId}/p/c/getCaptcha` : '/p/c/getCaptcha').then(res => resolve(res))
        })
      },

      // 普通模式登录
      async loginNet(url, globalServiceId, param) {
        this.spinShow = true;
        const captcha = await this.getCaptcha(globalServiceId);
        const limit = Object.assign({}, param, {captcha: captcha.data.captcha});

        limit.language = localStorage.getItem('r3-lang')
        if (limit.language === 'zh') {
          limit.language = 'zh_CN'
        }

        const r = await this.loginCore(enableGateWay() ? `/${this.globalServiceId}${url}` : url, limit);
        if (this.type) {
          if (r.code === 100) {
            const codes = await this.checkLogined();
            if (codes === 1001) {
              this.flag = 2;
              return this.login()
            }
          }
          if (r.code === -1) {
            if (this.typeToggle === 1) {
              this.$refs['AccountLogin'].$refs['ercode'].getCode();
              this.flag = 1;
            }
            return this.$Modal.fcWarning({
              title: t('安全提示'),
              content: r.message,
              mask: true,
            })
          }
          if (r.data && r.data.code === -1) {
            this.flag = 1;
          }
          if (r.data && r.data.code === 0) {
            this.flag = 1;
            const exp = r.data.data.isPasswordExpire;
            if (exp) {
              await this.checkPwdDays()
            }
          }
        }
        this.logined(r)
      },
      checkLogined() {
        return new Promise((resolve, reject) => {
          return this.$Modal.fcWarning({
            title: t('安全提示'),
            content: t('当前账号登录中，是否继续登录?'),
            mask: true,
            showCancel: true,
            onOk: () => resolve(1001),
            onCancel: () => {
              this.flag = 1;
              resolve(1002)
            }
          })
        })
      },
      // 登录中间层对接口返回进行处理-判断当前账号密码修改时间是否大于30天
      checkPwdDays(code) {
        return new Promise(resolve => {
          return this.$Modal.fcWarning({
            title: t('安全提示'),
            content: t('当前密码1个月未修改，为保数据安全请立即修改!'),
            mask: true,
            onOk: () => resolve()
          })
        })
      },

      loginCore(url, limit) {
        return new Promise((resolve, reject) => network.post(url, urlSearchParams(limit)).then(r => resolve(r)).catch((err, er) => {
          this.spinShow = false
          console.log('err', err.response)
          const res = err.response;
          const {message} = res.data;
          resolve(JSON.parse(message));
        }))
      },

      saveLastLoginPhone() {
        if (!(this.type && this.typeToggle === 2)) return;
        const phone = this.$refs.PhoneLogin && this.$refs.PhoneLogin.$refs.phone && this.$refs.PhoneLogin.$refs.phone.value;
        if (phone) {
          window.localStorage.setItem('lastLoginPhone', String(phone).trim());
        }
      },
      // 登录成功后的处理
      logined(r) {
        if (Version() === '1.3') {
          if (r.status === 200 && r.data.code === 1) {
            this.saveLastLoginPhone();
            if (r.data && r.data.user && r.data.user.userenv) {
              this.$store.commit('customize/setForcePasswordChange', r.data.user.forcePasswordChange)
              window.localStorage.setItem('userInfo', JSON.stringify(r.data.user.userenv));
            }
            localStorage.removeItem('fkRange')
            window.sessionStorage.setItem('loginTime', `${Date.now()}`);
            this.spinShow = false;
            this.goto()
          } else {
            this.spinShow = false;
          }
        } else if (r.status === 200 && r.data.code === 0) {
          this.saveLastLoginPhone();
          this.spinShow = false;
          window.sessionStorage.setItem('loginTime', `${Date.now()}`);
          this.goto()
        } else {
          this.spinShow = false;
        }
      },
      // 跳转前的回掉处理
      async goto() {
        // this.showChangeLang && await R3I18n(this.lang,{enableApi: true});

        // // 如果开启系统升级，且需要更新
        // const { enableSystemUpdate } = window.ProjectConfig
        // if(enableSystemUpdate && await this.checkUpdate()) {
        //   window.ProjectConfig.loginCallback = this.loginSucCbk
        //   this.$router.push({ path:'/R3UpdateSystem'})
        //   this.afterLogin()
        //   return
        // }

        if (!this.loginSucCbk) {
          // return window.location.href = window.location.origin
          await $i18n.lang(localStorage.getItem('locale') || 'zh', 1)
          this.$router.push({ path:'/'})
          await this.afterLogin()
          // fix: 在地址栏复制链接a进入框架界面，如果此时未登录，再重新登录，打开界面b,此时会同时存在a和b两个tab
          //（bug是由router.navigation.guard.js文件里搜下'saveNetwork'，这个关键字代码所在的循环定时器里的逻辑导致的）
          setTimeout(() => {
            this.emptyTabsCache()
          }, 200)
          return
        };
        if (typeof this.loginSucCbk !== 'function') throw new Error('loginSucCbk must be a function');
        const res = await this.loginSucCbk();
        if (!res) return;
        // window.location.href = window.location.origin;
        this.$router.push({ path:'/'})
        await this.afterLogin()
        setTimeout(() => {
          this.emptyTabsCache()
        }, 200)
      },

      // // 检查系统升级
      // async checkUpdate() {
      //   return new Promise((resolve) => {
      //     network.post(`/p/c/retail/queryLiquibaseExeStatus?hash=${new Date().getTime()}`).then(result => {
      //       const res = result.data
      //       if(res.code === 0) {
      //         // resolve(res.data.needUpdate)
      //         resolve(true)
      //       } else {
      //         resolve(false)
      //       }
      //     }).catch(() => {
      //       resolve(false);
      //     })
      //   })
      // },

      // 登录后处理事件
      async afterLogin() {
        await this.getUserInfo()

        const loginTime = window.sessionStorage.getItem('loginTime');
        if (loginTime && ((Date.now() - window.parseInt16(loginTime)) < 3000)) {
          if (cbs() && typeof (cbs().loginCb) === 'function') {
            cbs().loginCb();
          }
        }
        hideMenu();
        launchNetworkMonitor();
        emptyRecord(Date.now() - Number(dateStorageTime() ? dateStorageTime() : 1) * 24 * 1000 * 60 * 60);

        await this.getMenuLists()
      },

      async getUserInfo() {
        if (enableInitializationRequest()) {
          await network.get('/p/cs/hello').then((res) => {
            // 此方法用于向外界（JFlow）提供用户信息。供外部处理自己的需要逻辑。
            /* DispatchEvent('userReady', {
              detail: {
                userInfo: JSON.parse(JSON.stringify(res.data))
              }
            }); */
            const ev = new CustomEvent('userReady', {
              detail: {
                userInfo: JSON.parse(JSON.stringify(res.data))
              }
            });
            window.dispatchEvent(ev);
            if (res.status === 200 && res.data.code === 0) {
              this.$store.commit('global/updataUserInfoMessage', {
                userInfo: res.data
              });
              window.localStorage.setItem('userInfo', JSON.stringify(res.data));
              window.localStorage.setItem('sessionCookie',res.data.sessionCookie);
            }
          });
        }
      },

      resetPassword() {
        // 去掉输入框的默认填充
        this.$router.push({path:'/forgotPassword'})
        return
        setTimeout(() => {
          $("input").removeAttr("readonly")
        }, 1000);
        this.dialogShow = true
      },
      // 清空表单
      clearForm(formName) {
        this.$refs[formName].resetFields();
        this.updatePwdForm = {
          email: '',
          name: '',
					newpassword: '',
					confirmpassword: '',
          code: ''
        }
      },
      handleSubmit(formName) {
        this.$refs[formName].validate(valid => {
		   		if (valid) {
            this.checkLoading = true;
		   			const payload = this.updatePwdForm;
		   			// 提交修改
            network.post('/p/c/updPwdByCode',payload).then(res => {
              if (res.data.resultCode == 0) {
                this.checkLoading = false;
		   				  this.$refs[formName].resetFields()
                this.$Message.success(res.data.resultMsg);
                // 关闭弹窗
						    this.dialogShow = false
              } else {
                this.checkLoading = false;
                this.$Message.error(res.data.resultMsg)
              }
            }).catch(() => {});
          }else{
            return false;
          }
		   	});
      },
      sendEmailCode() {
        if (!this.updatePwdForm.name) {
          this.$Message.warning(t("用户名不能为空!"))
          return
        }
        this.$refs.updatePwdForm.validateField('email', result => {
          if(!result) {
            // 按钮倒计时
            this.disabled = true;
            this.msg = this.count-- + t('s后重新获取');
            this.timer = setInterval(() => {
              this.msg = this.count-- + t('s后重新获取');
              if (this.count < 0) {
                this.msg = t('点击获取验证码');
                this.count = 15;
                this.disabled = false;
                clearInterval(this.timer);
              }
            }, 1000);
             // 发送验证码请求
             const checkCode = {};
             checkCode.email = this.updatePwdForm.email;
             checkCode.name = this.updatePwdForm.name;
             network.post('/p/c/sendEmailByUpdPwd',checkCode).then(res => {
                if(res.data.resultCode == '0') {
                  // 通知邮箱发送
                  this.$notify({
                    title: t('邮箱验证码已发送'),
                      message: t('验证码有效时长30分钟, 失效请重新发送'),
                      type: 'success',
                      duration: 2000
                  })
                }else{
                  this.$Message.error(res.data.resultMsg)
                  this.msg = t('点击获取验证码');
                  this.count = 15;
                  this.disabled = false;
                  clearInterval(this.timer);
                }
              })
          }
        });
      },
    }
  };
</script>

<style lang="less">
.forgotPassword {
  cursor: pointer;
  position: absolute;
  // bottom: 8px;
  top: 129px;
  right: -6px;
  font-size: 14px;
  color: #002C57;
}
.para-widget-third-login__title {
  position: relative;
  margin-bottom: 20px;
  text-align: center;
  line-height: 12px;
  display: flex;
  color: #ffffff;
  .para-widget-third-login__line {
    flex: 1;
    height: 1px;
    margin-top: 5.5px;
    width: 30%;
    &.before {
      background: linear-gradient(270deg, #ffffff80 1.61%, #ffffff00 100%);;
      float: left;
    }
    &.after {
      background: linear-gradient(270deg, #ffffff00 1.61%, #ffffff80 100%);
      float: right;
    }
  }
  .para-widget-third-login__text {
    margin: 0 10px;
  }
}
.other-login-box {
  margin-top: 36px;
  color: #515767;
  /* display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; */
  .oauth-box {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    span {
      font-size: 13px;
      color: #515767;
    }
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #f2f3f5;
      margin-right: 8px;
      font-weight: 500;
    }
    .icon-wechat-:before {
      color: #0e932e;
    }
    .icon-dingding01:before {
      color: #3296FA;
    }
  }
}
</style>

<style lang="less" scoped>
.forgotPwdModal {
  /deep/ .el-dialog {
    border-radius: 6px !important;
    .el-form-item {
      display: flex;
      margin-bottom: 12px;
      .el-form-item__label {
        width: 90px;
      }
      .el-form-item__content {
        flex: 1;
      }
      .el-form-item__error {
        padding-top: 0;
      }
    }
  }
  /deep/ .el-input-group__append, .el-input-group__prepend {
    position: relative;
    padding: 0 8px !important;
    font-size: 12px;
    border: 0;
    button.el-button span {
      font-weight: 400;
    }
  }
  /deep/ .codeClass .el-form-item__content {
    .el-input__prefix .el-input__icon {
      line-height: 32px !important;
    }
  }
  /deep/ input::placeholder {
    font-size: 12px;
  }
}
// 登录按钮loading
#btn {
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    .ark-icon {
      position: relative;
      width: 16px;
      right: 7px;
      font-size: 16px;
      animation: rotate-animation 2s infinite;
    }
  }
}
@keyframes rotate-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
